import { useSyncExternalStore } from 'react';

const QUERY = '(max-width: 768px)';

export const useIsMobile = (): boolean => {
  return useSyncExternalStore(
    (onStoreChange) => {
      const mediaQuery = window.matchMedia(QUERY);
      mediaQuery.addEventListener('change', onStoreChange);
      return () => mediaQuery.removeEventListener('change', onStoreChange);
    },
    () => window.matchMedia(QUERY).matches,
    () => false,
  );
};
